import React from "react";

import {
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBCardFooter,
  MDBCardImage,
  MDBCardTitle
} from 'mdb-react-ui-kit';

import './UsuarioNoticias.css';


export class UsuarioNoticias extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      noticias: [],
      imagenAutor: props.imagenAutor,
      nombreAutor: props.nombreAutor,
      fecha: props.fecha,
      titulo: props.titulo,
      imagen: props.imagen,
    };
  }

  render() {
    return (
      <MDBCard style={{ marginBottom: '20px' }}>
        {this.props.imagen ?
          <MDBCardImage src={this.props.imagen} position='top' alt='...' />
          : <></>
        }
        <MDBCardBody>
          <MDBCardTitle>{this.props.titulo}</MDBCardTitle>
          <div className="d-flex align-items">
            <div style={{ flexShrink: 0 }}>
              <img
                src={this.props.imagenAutor}
                alt=""
                style={{ width: "45px", height: "45px" }}
                className="rounded-circle"
              />
            </div>

            <div className="ms-3 d-flex flex-column">
              <p className="fw-bold mb-2">{this.props.nombreAutor}</p>
              <p className="mb-0" style={{ overflowWrap: "break-word", wordBreak: "break-word" }}>
                {this.props.noticia}
              </p>
            </div>
          </div>
        </MDBCardBody>

        <MDBCardFooter className="d-flex justify-content-between align-items-center text-muted py-3">
          <MDBBtn outline toggle rounded className='mx-2' color='secondary' href="#">Ir a la Noticia</MDBBtn>

          <div className="d-flex align-items-center ms-auto">
            <span>{this.props.fecha}</span>
          </div>
        </MDBCardFooter>
      </MDBCard>
    )
  }
};

export default UsuarioNoticias;
